/**
 * @generated SignedSource<<eba21ca5bb83c1d92876426aaace2872>>
 * @relayHash d57ff412eb24099f77d2f9faba26f069
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 38f691799d27e0e21a7e36ac28ac845f836fcbc9359f06ceeaf8c9bce75d1993

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcIncidentsPageInternalQuery } from './srcIncidentsPageInternalQuery.graphql';

const node: PreloadableConcreteRequest<srcIncidentsPageInternalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "38f691799d27e0e21a7e36ac28ac845f836fcbc9359f06ceeaf8c9bce75d1993",
    "metadata": {
      "connection": [
        {
          "count": "servicePageSize",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "jiraProjectByKey",
            "linkedOperationsComponentsByProject"
          ]
        }
      ]
    },
    "name": "srcIncidentsPageInternalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
